export const formItemLayoutDefault = {
  labelCol: {
      span: 4
  },
  wrapperCol: {
      span: 20
  },
}

export const formItemLayoutVerticalDefault = {
  labelCol: {
      span: 4
  },
  wrapperCol: {
      span: 24
  },
}

export const formItemLayoutSplit = {
  labelCol: {
      span: 8
  },
  wrapperCol: {
      span: 16
  },
}
